import { z } from 'zod';

export const MyMetricStaticControlVariableDefinition = z.object({
  columnHeaderValue: z.string(),
  name: z.string(),
});

export type MyMetricStaticControlVariableDefinition = z.infer<
  typeof MyMetricStaticControlVariableDefinition
>;
